import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col
} from "reactstrap";
import {Form, useNavigate} from "react-router-dom";
import appInsights from "../log/appInsights";
import { useState, useEffect, useRef } from "react";
import { toast, ToastContainer } from 'react-toastify'

function Login() {

  const API_URL = process.env.REACT_APP_API_URL;

  const [formData, setFormData] = useState({email: '', senha: ''});
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const emailRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    emailRef.current?.focus();    
  }, [])

  useEffect(() => {
    if (status) {
      toast.warn(status);
      setStatus(null);
      emailRef.current?.focus();
    }
  }, [status])

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.senha) {
      setStatus("O e-mail e a senha de acesso devem ser fornecidos.");      
    }
    else {
      try {
        setLoading(true);
        setStatus(null);
        const response = await fetch(API_URL, {
          method: "POST",
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            name: 'login',
            params: {
              username: formData.email,
              password: formData.senha
            }
          })
        })

        if (!response.ok) {
          const result = await response.json();
          setStatus(result.message);
        }
        else {
          const result = await response.json();
          const user = result.user;
          localStorage.setItem('@ProsperBI:bpoToken', user.bpo_token);
          localStorage.setItem('@ProsperBI:pbiToken', user.pbi_token);
          localStorage.setItem('@ProsperBI:email', user.email);
          localStorage.setItem('@ProsperBI:foto', user.foto);

          appInsights.trackEvent({
            name: "actionLogin",
            properties: {
              action: "Login",
              timestamp: new Date().toISOString(),
            },
          });

          await fetch(API_URL, {
            method: "POST",
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              name: 'security',
              params: {
                bpoToken: user.bpo_token,
                eventType: 'login'
              }
            })
          })

          return navigate("/admin");
        }        
      }
      catch (error) {
        console.error(error);
        setStatus('Erro ao realizar a autenticação.');
      }
      finally {
        setLoading(false);
      }
    }
  }

  const handleChange = (e) => {
    setFormData({...formData, [e.target.name]: e.target.value});
  }   

  return (
    <>
      <ToastContainer position="top-right" />
      <Col lg="5" md="7">
        <Card className="bg-secondary shadow border-0">
          <CardHeader className="bg-transparent ">
            <div className="text-muted text-center mt-2">
              <small>REALIZE A SUA AUTENTICAÇÃO</small>
            </div>
          </CardHeader>
          <CardBody className="px-lg-5 py-lg-5">
            <Form method="post" onSubmit={handleSubmit} >
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-email-83" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    id='emaail'
                    name='email'
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="E-Mail"
                    type="email"
                    autoComplete="new-email"
                    innerRef={emailRef}
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    id='senha'
                    name='senha'
                    value={formData.senha}
                    onChange={handleChange}
                    placeholder="Senha"
                    type="password"
                    autoComplete="new-password"
                  />
                </InputGroup>
              </FormGroup>
              <div className="text-center">
                <Button className="my-1" color="primary" type="submit" disabled={loading}>                  
                  Autenticar
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
        <Row className="mt-3">
          <Col xs="6">
            <a
              className="text-light"
              href="#p1"
              onClick={() => navigate("/recover")}
            >
              <small>Esqueceu a senha?</small>
            </a>
          </Col>
        </Row>
      </Col>
    </>
  );
}

export default Login;
